/**
 * @flow
 * @relayHash 713e33e9a6bc382f71f4e53065b825c6
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type CurrencyCreateInput = {|
  name: string,
  code: string,
|};
export type CreateCurrencyMutationVariables = {|
  data: CurrencyCreateInput
|};
export type CreateCurrencyMutationResponse = {|
  +createCurrency: {|
    +id: string
  |}
|};
export type CreateCurrencyMutation = {|
  variables: CreateCurrencyMutationVariables,
  response: CreateCurrencyMutationResponse,
|};
*/


/*
mutation CreateCurrencyMutation(
  $data: CurrencyCreateInput!
) {
  createCurrency(data: $data) {
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "data",
    "type": "CurrencyCreateInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "createCurrency",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "data",
        "variableName": "data"
      }
    ],
    "concreteType": "CurrencyModel",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "CreateCurrencyMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "CreateCurrencyMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "CreateCurrencyMutation",
    "id": null,
    "text": "mutation CreateCurrencyMutation(\n  $data: CurrencyCreateInput!\n) {\n  createCurrency(data: $data) {\n    id\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'b15028007c6fbde1534615d3c6792833';
module.exports = node;
